import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './components/ds';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout/Layout';
import LoginPage from './pages/Login/PortalLogin';
import AdsList from './pages/AdsList/AdsList';
import CreateAdWizard from './pages/CreateAd/CreateAdWizard';
import AdDetail from './pages/AdDetail/AdDetail';
import CreativeEditor from './pages/CreativeEditor/CreativeEditor';
import CategoryViewer from './pages/CategoryViewer/CategoryViewer';

export default function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/dev/category-viewer" element={<CategoryViewer />} />

          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route path="/ads" element={<AdsList />} />
              <Route path="/ads/create" element={<CreateAdWizard />} />
              <Route path="/ads/:id" element={<AdDetail />} />
              <Route path="/ads/:id/creative" element={<CreativeEditor />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </ToastProvider>
    </AuthProvider>
  );
}
